import type { dayjs } from "@/lib/dayjs";
import type { Dispatch, SetStateAction } from "react";
import type { CalendarFilter } from "./Calendar";
import { Months } from "./Months";

type Props = {
  filters: Array<CalendarFilter>;
  setFilters: Dispatch<SetStateAction<CalendarFilter[]>>;
  allDates: Array<dayjs.Dayjs>;
  dates: Array<dayjs.Dayjs>;
  setDates: Dispatch<SetStateAction<Array<dayjs.Dayjs>>>;
};
export const Filters = ({ filters, setFilters, allDates, dates, setDates }: Props) => {
  const handleClick = (filter: CalendarFilter) => {
    if (filters.includes(filter)) {
      setFilters(filters.filter((v) => v !== filter));
    } else {
      setFilters([...filters, filter]);
    }
  };

  return (
    <>
      <p className="text-base leading-5 font-semibold italic text-primary mb-4 mt-16">
        Pour masquer une catégorie appuyez sur le bouton correspondant
      </p>
      <div className="flex flex-col xl:flex-row xl:justify-between space-y-3 xl:space-y-0 mb-16 xl:items-center">
        <div>
          <label className="cursor-pointer relative flex items-center select-none">
            <input
              type="checkbox"
              className="hidden peer"
              checked={filters.includes("Journées culturelles")}
              onChange={() => handleClick("Journées culturelles")}
            />
            <div className="bg-pr-1 rounded-full w-14 h-7 transition-all peer-checked:bg-[#195A88] shadow-inner outline-hidden" />
            <div className="absolute transition-all w-5 h-5 rounded-full left-1 top-1 bg-white peer-checked:left-8 drop-shadow-sm" />
            <p className="text-sm text-primary uppercase font-semibold ml-2">Journées culturelles</p>
          </label>
        </div>
        <div>
          <label className="cursor-pointer relative flex items-center select-none">
            <input
              type="checkbox"
              className="hidden peer"
              checked={filters.includes("Promenades culturelles")}
              onChange={() => handleClick("Promenades culturelles")}
            />
            <div className="bg-pr-1 rounded-full w-14 h-7 transition-all peer-checked:bg-[#EB7D3C] shadow-inner outline-hidden" />
            <div className="absolute transition-all w-5 h-5 rounded-full left-1 top-1 bg-white peer-checked:left-8 drop-shadow-sm" />
            <p className="text-sm text-primary uppercase font-semibold ml-2">Promenades culturelles</p>
          </label>
        </div>
        <div>
          <label className="cursor-pointer relative flex items-center select-none">
            <input
              type="checkbox"
              className="hidden peer"
              checked={filters.includes("Conférences")}
              onChange={() => handleClick("Conférences")}
            />
            <div className="bg-pr-1 rounded-full w-14 h-7 transition-all peer-checked:bg-[#044B3E] shadow-inner outline-hidden" />
            <div className="absolute transition-all w-5 h-5 rounded-full left-1 top-1 bg-white peer-checked:left-8 drop-shadow-sm" />
            <p className="text-sm text-primary uppercase font-semibold ml-2">Conférences</p>
          </label>
        </div>
        <div>
          <label className="cursor-pointer relative flex items-center select-none">
            <input
              type="checkbox"
              className="hidden peer"
              checked={filters.includes("Café-Conférences")}
              onChange={() => handleClick("Café-Conférences")}
            />
            <div className="bg-pr-1 rounded-full w-14 h-7 transition-all peer-checked:bg-[#00B25D] shadow-inner outline-hidden" />
            <div className="absolute transition-all w-5 h-5 rounded-full left-1 top-1 bg-white peer-checked:left-8 drop-shadow-sm" />
            <p className="text-sm text-primary uppercase font-semibold ml-2">Café-Conférences</p>
          </label>
        </div>
        <Months allDates={allDates} dates={dates} setDates={setDates} />
      </div>
    </>
  );
};
